$(function () {
    if ($('.rethinkers-slider-share').length) {
        $('.slick-share-container').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            asNavFor: '.slick-text-container',
            prevArrow: '<span class="slider-share--prev slider-arrow"><span class="icon icon-left-dir"></span></span>',
            nextArrow: '<span class="slider-share--next slider-arrow"><span class="icon icon-right-dir"></span></span>',
        });
    }

    if ($('.rethinkers-slider-share').length) {
        $('.slick-text-container').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            infinite: true,
        });
    }
});
